import { combineReducers } from "redux";
import { reducer as toastr } from "react-redux-toastr";
import { reducer as betaModal } from "redux-modal";
import { reducer as auth } from "./modules/auth/reducer";
import { reducer as appSetup } from "./modules/appSetup/reducer";
import issues from "./modules/issues";
import { reducer as betaIssues } from "./modules/_BETA/issues";
import { reducer as users } from "./modules/users/reducer";
import { reducer as groups } from "./modules/groups/reducer";
import { reducer as lookups } from "./modules/lookups/reducer";
import { reducer as profile } from "./modules/profile/reducer";
import { reducer as monthlySummary } from "./modules/monthlySummary/reducer";
import { reducer as betaIssue } from "./modules/_BETA/issue";
import { reducer as attachments } from "./modules/attachments/reducer";
import { reducer as insights } from "./modules/insights/reducer";
import { reducer as betaAssociate } from "./modules/_BETA/associate";
import { reducer as betaUnassociate } from "./modules/_BETA/unassociate";
import { reducer as betaSnooze } from "./modules/_BETA/snooze";
import { reducer as betaUnsnooze } from "./modules/_BETA/unsnooze";
import { reducer as betaAction } from "./modules/action/reducer";
import { reducer as betaActionsUI } from "./modules/_BETA/actionsUI";
import { reducer as requestSchedule } from "./modules/_BETA/requestSchedule";
import reportGenerator from "./modules/reportGenerator";
import { reducer as betaSelections } from "./modules/_BETA/selections";
import { reducer as userSites } from "./modules/userSites/reducer";
import { reducer as urlHistory } from "./modules/urlHistory/reducer";
import { reducer as monitoring } from "./modules/monitoring/reducer";

export const rootReducer = combineReducers({
  toastr,
  auth,
  issues: issues as any,
  users: users as any,
  groups,
  lookups,
  profile,
  monthlySummary,
  attachments,
  reportGenerator,
  // BETA Reducers
  appSetup,
  betaModal,
  userSites,
  betaSelections,
  betaIssues: betaIssues as any,
  betaIssue,
  insights,
  betaAction,
  betaActionsUI,
  betaAssociate,
  betaUnassociate,
  betaSnooze,
  betaUnsnooze,
  requestSchedule,
  urlHistory,
  monitoring,
});

/**
 * The entire application state.
 *
 * Useful for typing `mapStateToProps` function parameters.
 */
export type AppState = ReturnType<typeof rootReducer>;

/**
 * Custom clientMiddleware action return type. This is inherently unsafe as the
 * middleware may return different things based on success/failure and may
 * require different payloads. See `src/redux/middleware/clientMiddleware.js`
 * for more information.
 */
export interface AsyncAction {
  types: [string, string, string];
  promise(client: any): Promise<any>;
  [key: string]: any;
}
